import React from "react";
import PropTypes from "prop-types";
import styles from "./FlexItemContainer.module.css";

const FlexItemContainer = (props) => {
  return (
    <div
      className={styles.flexItemContainer}
      style={{
        ...props.style,
        ...(props.directionIsRow && { flexDirection: "row", gap: "10px" }),
        ...(props.width && {
          width: props.width,
          minWidth: props.width,
          maxWidth: props.width,
        }),
        ...(props.height && {
          height: props.height,
          minHeight: props.height,
          maxHeight: props.height,
        }),
        ...(props.isChild && { padding: "0px 0px 0px 10px" }),
      }}
    >
      {props.children}
    </div>
  );
};

FlexItemContainer.defaultProps = {
  directionIsRow: false,
  isChild: false,
};

FlexItemContainer.propTypes = {
  directionIsRow: PropTypes.bool,
  flexDirection: PropTypes.string,
  style: PropTypes.any,
  width: PropTypes.string,
  height: PropTypes.string,
  isChild: PropTypes.bool,
};

export default FlexItemContainer;
